import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';

import { translate } from 'containers/services/translate';
import BannerIdentifacation from 'images/Banner-Identifacation-Contract.png';
import messages from 'containers/IdentificationPage/messages';

import GATracking from 'components/GATracking/index';
import NewSearchBar from 'components/NewSearchBar';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { SearchQuery } from 'containers/IdentificationPage/typings';
import { validateSearchQuery } from 'containers/IdentificationPage/utils';

export interface IdentificationPageProps {
  intl: IntlShape;
  submitSearch: Function;
  searchQuery: SearchQuery;
  onChangeSearchQuery: Function;
  isManager?: boolean;
}

const Container = styled.div`
  &&.container {
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(${BannerIdentifacation});
    background-position: center;
    background-repeat: no-repeat;
    height: 219px;
    width: 100%;
    box-shadow: 0px 1px 2px #0000001f;
    margin-top: ${props => (props.hidden ? '50px' : '75px')};
  }
  .searchContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .inputContainer {
    display: flex;
    margin-top: 28px;
  }
  .input {
    padding: 2px 4px;
    height: 46px;
    width: 30%;
    border-radius: 4px;
    margin: 0px 5px;
    border: 1px solid #0279c2;
    background-color: #fafafa;
  }
  .inputTextStyle {
    text-align: left;
    font: Regular 14px Roboto;
    letter-spacing: 0;
    color: #707891;
    padding: 10px 0;
    width: 200px;
  }
  .containerSearch {
    margin-top: 10px;
  }
  .inputTextStyleDate {
    text-align: left;
    font: Regular 14px Roboto;
    letter-spacing: 0;
    color: #707891;
    padding: 5px 0;
  }
  .inputBase {
    margin-left: 5px;
    flex: 1;
  }
  .title {
    text-align: center;
    font: Bold 24px Roboto;
    letter-spacing: 0;
    color: #ffffff;
    margin-bottom: 18px;
  }
  .subTitle {
    text-align: center;
    font: Regular 14px Roboto;
    letter-spacing: 0;
    color: #ffffff;
  }
  .searchButton {
    width: 126px;
    height: 46px;
    padding: 2px 4px;
    background-color: #f9be00;
    border: 1px solid #f9be00;
    text-align: center;
    font: Medium 15px Roboto;
    letter-spacing: 0.03px;
    color: #333e48;
    border-radius: 4px;
    margin: 0px 5px;
  }
  .dateInput {
    background: #fafafa 0 % 0 % no - repeat padding - box;
    height: 100%;
    border: none;
  }
  .error {
    margin-top: 10%;
    color: red;
  }
  .error-5 {
    margin-top: 8%;
    color: red;
  }
`;

const SearchContainer: React.FC<IdentificationPageProps> = (
  props,
): JSX.Element => {
  const submitSearchQuery = () => {
    if (validateSearchQuery(props.searchQuery, ['lossDate'])) {
      GATracking.event(
        GATracking.EVENT_CATEGORIES.SEARCH,
        'Lawyer contract identification',
      );
      props.submitSearch();
    }
  };

  return (
    <Container className="container" hidden={!props.isManager}>
      <div className="searchContainer">
        <Typography className="title">
          {props.isManager
            ? translate({ ...messages.searchManagerContainerTitle }, props)
            : translate({ ...messages.searchContainerTitle }, props)}
        </Typography>
        <Typography className="subTitle">
          {props.isManager
            ? translate({ ...messages.searchManagerContainerSupTitile }, props)
            : translate({ ...messages.searchContainerSupTitile }, props)}
        </Typography>
        {featureService.hasFeature(FEATURES.SEARCH_BAR) && (
          <div className="containerSearch">
            <NewSearchBar
              searchQuery={props.searchQuery}
              setSearchQuery={props.onChangeSearchQuery}
              handlerSearch={submitSearchQuery}
              handlerRefresh={() => {}}
              isHomePage={true}
              showAll={props.isManager}
            />
          </div>
        )}
      </div>
    </Container>
  );
};

SearchContainer.defaultProps = {
  isManager: false,
};

export default injectIntl(SearchContainer);
